import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { ForceChangePasswordModal } from './ForceChangePasswordModal';

interface AdminProtectedRouteProps {
  children: React.ReactNode;
}

export const AdminProtectedRoute: React.FC<AdminProtectedRouteProps> = ({ children }) => {
  const { user, isAuthenticated, loading, mustChangePassword } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Redirect to admin login page
    return <Navigate to="/admin" state={{ from: location }} replace />;
  }

  // Check if user is a superuser (admin)
  if (!user?.is_superuser) {
    // Redirect non-admin users to home
    return <Navigate to="/" replace />;
  }

  // Show force change password modal if user must change password
  if (mustChangePassword) {
    return (
      <>
        {children}
        <ForceChangePasswordModal isOpen={true} />
      </>
    );
  }

  return <>{children}</>;
};
